import { IconProps } from 'src/utils/icon';

const ApplicationsIcon: React.FC<IconProps> = ({ size = 1 }) => (
  <svg
    style={{ fontSize: `${size}rem` }}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 34 34"
  >
    <path
      fill="#fff"
      stroke="#2c2a29"
      strokeMiterlimit="10"
      strokeWidth="2.5"
      d="M13.198 1.49H1.306v11.978h11.892V1.49zM32.439 1.315H20.546v11.978h11.893V1.315zM32.7 20.692H20.807v11.977H32.7V20.692zM13.198 20.692H1.306v11.977h11.892V20.692z"
    />
  </svg>
);

export default ApplicationsIcon;
